module.exports = __webpack_public_path__ + "index_assets/img/logo.854e408d.png";